import request from "libs/request"

// 登录
export function loginIn(data) {
  return request({
    url: '/login/login.do',
    headers: {
      locker: new Date().getTime()
    },
    method: 'POST',
    data: data
  })
}

// 登出
export function loginOut() {
  return request({
    url: '/login/logout.do',
    headers: {
      locker: new Date().getTime()
    },
    method: 'get',
  })
}

// 修改密码
export function resetPassword(data) {
  return request({
    url: '/login/password.do',
    headers: {
      locker: new Date().getTime()
    },
    method: 'post',
    data: data
  })
}